"use client";

import { FileQuestion } from "lucide-react";
import { Button } from "@/components/ui";
import { useRouter } from "next/navigation";

interface NotFoundProps {
  title?: string;
  message?: string;
  showBackButton?: boolean;
  backHref?: string;
  backLabel?: string;
}

export function NotFound({
  title = "Bulunamadı",
  message = "Aradığınız kayıt bulunamadı.",
  showBackButton = true,
  backHref = "/dashboard",
  backLabel = "Ana Sayfaya Dön"
}: NotFoundProps) {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
        <FileQuestion className="w-8 h-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        {title}
      </h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        {message}
      </p>
      {showBackButton && (
        <Button onClick={() => router.push(backHref)} variant="secondary">
          {backLabel}
        </Button>
      )}
    </div>
  );
}
